// Affiche « Me prévenir » quand le coloris choisi est indisponible (événement natif variant:update).
const slug = (s) => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

document.addEventListener('variant:update', (event) => {
  const variant = event.detail?.resource;
  if (!variant) return;
  document.querySelectorAll('.kf-restock').forEach((box) => {
    box.dataset.available = String(variant.available !== false);
    const name = box.querySelector('[data-restock-name]');
    if (name) name.textContent = variant.title;
    const tags = box.querySelector('[data-restock-tags]');
    if (tags) tags.value = `attente-dispo,dispo-${slug(variant.title)}`;
  });
});
